import Crud from '../components/MultipleSignature/Crud'
import MultipleSignature from '../components/MultipleSignature/MultipleSignature'

let routes = {
    path: '/multipleSignature',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
        path: '/multipleSignature',
        name: 'Assinaturas Múltiplas',
        component: Crud
      },      
      {
          path: '/multipleSignature/send',
          name: 'Envio de Assinatura Múltipla',
          component: MultipleSignature
      },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/multipleSignature.js